var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-680 -103)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 25,
    height: 25,
    transform: "translate(680 103)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.426 106)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.854,6.158H58.6V0H52.151V6.158H47.9l7.476,9.072Z",
    transform: "translate(-23.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16.702,
    height: 2.592,
    transform: "translate(23.574 15.805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.ae15b20844618d3faac9842951d215f6.svg";
export { ForwardRef as ReactComponent };